import _ from 'lodash';

function Controller(UserComponent, Auth, Currencies, ValidationService, $window, $state, $stateParams, $scope, $filter, ClientComponent, TicketComponent, DiscountComponent, PageHeading, Toast, Seat) {
	'ngInject';

	const vm = this;
	vm.textValidation = ValidationService.textValidation;
	vm.submitReservation = submitReservation;
	vm.openCreateNewClientForm = openCreateNewClientForm;
	vm.searchClients = ClientComponent.searchClients;
	vm.getResultSearchClients = ClientComponent.getResultSearchClients;
	vm.clearResults = clearResults;
	vm.selectItemFromAutocomplete = selectItemFromAutocomplete;
	vm.selectSeat = selectSeat;
	vm.client = {};
	vm.selectedClient = {};
	vm.isValidIdNumber = isValidIdNumber;
	vm.getDiscounts = DiscountComponent.getDiscounts;
	vm.chooseDiscount = chooseDiscount;
	vm.seats = [];
	vm.returnSeats = [];
	vm.seat = JSON.parse(JSON.stringify(Seat));
	vm.seatType = vm.seat.ticket.status;
	vm.deleteReservation = deleteReservation;
	vm.busId = $stateParams.busId;
	vm.editPrice = [];
	vm.hasPermission = '';
	vm.clearUserResults = UserComponent.clearUsers;
	vm.fetchUsers = UserComponent.fetchUsers;
	vm.getUsers = UserComponent.getUsers;
	vm.selectUser = selectUser;

	activate();
	init();

	function init() {
		if (Seat.ticket.discount) {
			chooseDiscount(Seat.ticket.discount);
			getDiscoutText();
		} else {
			ticketPrice();
			getDiscoutText();
		}
	}

	function activate() {
		const heading = $filter('translate')('HEADING.EDITING_TICKET');
		const title = `BTMS | ${$filter('translate')('HEADING.EDITING_TICKET') }`;

		hasPermission(['owner', 'administrator', 'office']);
		PageHeading.setPageHeading(heading, title);

		// Build reservation object
		vm.reservation = {
			'arrives_at': $filter('dateParser')(Seat.sub_line.bus.arrives_at, 'YYYY-MM-DD HH:mm:ss'),
			'bus_id': vm.busId || Seat.bus_id,
			'client_id': Seat.ticket.client_id,
			'departs_at': $filter('dateParser')(Seat.sub_line.bus.departs_at, 'YYYY-MM-DD HH:mm:ss'),
			'discount_id': vm.seat.ticket.discount_id,
			'number': Seat.number,
			'note': Seat.ticket.note,
			'sub_line_id': Seat.sub_line.id,
			'status': vm.seat.ticket.status || Seat.status,
			'ticket_number': Seat.ticket.number,
			'user_id': Seat.ticket.user ? Seat.ticket.user.id : Auth.getCurrentUser().id
		};
		// Set discount if any
		if (Seat.discount) {
			chooseDiscount(Seat.discount);
		}
		// Set client data
		selectItemFromAutocomplete(Seat.ticket.client);

		// Select the seat user is editing
		const selectedSeat = _.find(vm.seat.sub_line.seats, { 'number': Seat.number });
		if (Seat.sub_line_id === Seat.sub_line.id && Seat.departs_at === Seat.sub_line.bus.departs_at) {
			selectedSeat.color = 'selected';
			selectedSeat.status = 'free';
		}
	}

	/** */
	function getDiscoutText() {
		let discoutText = {};

		if (Seat.ticket.discount) {
			if (Seat.ticket.discount.translation) {
				discoutText = `${ Seat.ticket.discount.translation.name }: -${ Seat.ticket.discount.value } ${ Seat.ticket.discount.type === 'percent' ? '%' : '' }`;
			} else {
				discoutText = `${ Seat.ticket.discount.value } ${ Seat.ticket.discount.type === 'percent' ? '%' : '' }: -${ Seat.ticket.discount.value } ${ Seat.ticket.discount.type === 'percent' ? '%' : '' }`;
			}
		} else {
			discoutText = $filter('translate')('WITHOUT_DISCOUNT');
		}

		const discount = {
			'translation': {
				'name': discoutText
			}
		};

		vm.discount = discount;
	}


	function submitReservation(selectedClient, newClient, reservation) {
		let hasErrors = false;

		if ($scope.createReservation.$error.required && vm.textValidation(vm.client.names)) {
			hasErrors = true;

			return false;
		}

		if (hasErrors || !reservation.status) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if (!reservation.number) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_GOING_SEAT'));

			return false;
		}

		if (selectedClient.id) {
			const areNamesChanged = selectedClient.names !== newClient.names;
			const isIdNumberChanged = selectedClient.id_number !== newClient.id_number;
			const isEmailChanged = selectedClient.email !== newClient.email;
			const isPhoneChanged = selectedClient.phone !== newClient.phone;

			if (areNamesChanged || isIdNumberChanged || isEmailChanged || isPhoneChanged) {
				// Selected client data has been modified. Client should be updated.
				ClientComponent.updateClient(selectedClient.id, newClient)
					.then(function (res) {
						if (res.data.errors) {
							Toast.responseError(res.data.errors);
						} else {
							reservation.client_id = selectedClient.id;
							updateReservation(reservation);
						}
					});
			} else {
				reservation.client_id = selectedClient.id;
				updateReservation(reservation);
			}
		} else {
			// There is no selected client. Create new client.
			ClientComponent.createClient(newClient)
				.then(function (res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						reservation.client_id = res.data.data.id;
						updateReservation(reservation);
					}
				});
		}
	}

	function updateReservation(params) {
		TicketComponent.updateTicket(Seat.id, params)
			.then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.UPDATE_TICKET'));
					$state.go('app.private.sales.show', { 'ticketId': Seat.ticket.id });
				}
			});
	}

	function openCreateNewClientForm() {
		$scope.createReservation.$setPristine();
		vm.client = {};
		vm.selectedClient = {};
		vm.query = '';
	}

	function clearResults() {
		ClientComponent.clearResultSearchClients();
	}

	function selectItemFromAutocomplete(result) {
		vm.query = '';
		vm.selectedClient = result;
		vm.client.names = result.names;
		vm.client.id_number = result.id_number;
		vm.client.email = result.email;
		vm.client.phone = result.phone;
	}

	function isValidIdNumber(idNumber) {
		return /[0-9]{10}/.test(idNumber) || idNumber.length === 10;
	}

	function selectSeat(seat) {
		if (seat.active && seat.color !== 'selected') {
			Toast.error($filter('translate')('ERRORS.TAKEN_SEAT'));

			return false;
		}

		vm.reservation.number = seat.number;

		vm.seats.forEach((item) => {
			if (item.active && item.status === 'free') {
				item.active = false;
			}
		});

		seat.active = true;
		seat.color = 'selected';
	}

	/** */
	function chooseDiscount(discount = {}) {
		let discountValue = null;

		if (discount.id) {
			vm.discount = discount;
			vm.reservation.discount_id = discount.id;
			let value = null;
			discountValue = parseInt(discount.value, 10);

			ticketPrice().forEach((currency, index) => {
				if (discount.type === 'value') {
					value = currency.value - discountValue / Currencies[index].exchange_rate;
					currency.value = value.toFixed(2);

					return vm.ticketPrice;
				} else {
					value = currency.value - currency.value / 100 * discountValue;
					currency.value = value.toFixed(2);

					return vm.ticketPrice;
				}
			});
		} else {
			vm.discount = {'translation': {'name': $filter('translate')('WITHOUT_DISCOUNT')}};
			delete vm.reservation.discount_id;

			return  ticketPrice();
		}
	}
	/** */
	function deleteReservation() {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			TicketComponent.deleteTicket(Seat.ticket_id)
				.then(function (res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					}
					history.back();
				});
		}
	}

	/** Create price object set value and currency code
	 * @return { Object } - vm.editPrice - Ticket price in different currencies
	*/
	function ticketPrice() {
		vm.editPrice = [];
		let price = {};

		for (let i = 0, max = Seat.ticket.price_without_discount.length; i < max; i++ ) {
			price = {
				'value': sumPrice(Seat.ticket.price_without_discount[i], 0, Currencies[i].exchange_rate),
				'code': Seat.ticket.price_without_discount[i].code
			};

			vm.editPrice.push(price);
		}

		return vm.editPrice;
	}

	/** Calculate ticket price
	 * @params { Array } - firstArr - going line
	 * @params { Array } - secondArr - return line
	 * @return { Number } calculatedPrice - final calculated price
	 */
	function sumPrice(firstArr, secondArr, rate) {
		let calculatedPrice = '';
		const discount = 0;

		if ( secondArr === 0 ) {
			calculatedPrice = firstArr.value - discount / rate;
		} else {
			calculatedPrice = firstArr.value + secondArr.value - discount / rate;
		}

		return calculatedPrice.toFixed(2);
	}

	/** Check current user permissions
	 * @params { Array } - usersWithPermission array of permited user roles
	 * @return { Boolean }
	 */
	function hasPermission(usersWithPermission) {
		const curretUser = Auth.getCurrentUser().roles[0].name;

		if (vm.hasPermission === '' && usersWithPermission.indexOf(curretUser) !== -1) {
			vm.hasPermission = true;
		} else {
			vm.hasPermission = false;
		}


		return vm.hasPermission;
	}
	
	/** */
	function selectUser(user) {
		vm.userQuery = user.name || user.names;
		vm.reservation.user_id = user.user[0].id;
	}
}

export default Controller;



/** WEBPACK FOOTER **
 ** ./client/private/tickets/edit/edit.controller.js
 **/